import { Button, Grid } from '@material-ui/core';
import { TextField, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { withStyles } from '@material-ui/core/styles';
import styles from './ServiceCaseStyles';
import { useMediaQuery } from '@mui/material';

const Fields = ({
    classes,
    fieldInitBy, filterStatus,
    fieldInitEmail, fieldInitRefCode, handleInitBy, handleStatus, handleEmail, handleRefCode, handleFieldSubmit, handleReset, handleDownloadCsv

}) => {

    const screen1620px = useMediaQuery("(max-width:1620px)") //dev-trupti on 24-10-2024
    //commented the code by dev-trupti on 24-12-2024
    // const textFieldProps = {
    //     InputLabelProps: {
    //         style: {
    //             color: '#FFFFFF',
    //             fontFamily: 'cardiuma-regular',
    //             fontSize: '14px',
    //             fontStyle: 'normal',

    //         }
    //     },

    //     InputProps: {
    //         style: {
    //             color: '#FFFFFF',
    //             width: '100%',
    //             height: '100%'
    //         }
    //     },

    //     style: {
    //         width: screen1620px? '210px': '240px', //dev-trupti on 24-10-2024
    //         height: '40px',
    //         marginRight: '1%',
    //         backgroundColor: '#131E2E'
    //     }
    // }
    // //Added styles by dev-trupti 22-10-2024
    // const smalltextFieldProps = {
    //     InputLabelProps: {
    //         style: {
    //             color: '#FFFFFF',
    //             fontFamily: 'cardiuma-regular',
    //             fontSize: '14px',
    //             fontStyle: 'normal'
    //         }
    //     },

    //     InputProps: {
    //         style: {
    //             color: '#FFFFFF',
    //             width: '100%',
    //             height: '100%'
    //         }
    //     },

    //     style: {
    //         width: screen1620px? '150px': '180px', //dev-trupti on 24-10-2024
    //         height: '48px',
    //         marginRight: '1%',
    //         backgroundColor: '#131E2E'
    //     }
    // }

    const textFieldStyles = {
        marginRight: '10px !important',
        '& .MuiInputBase-root': {
            backgroundColor: '#131E2E !important',
            color: 'white !important',
            fontFamily: 'cardiuma-regular',
            fontSize: '15px'
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '131E2E !important',
        },
        '& .MuiInputLabel-root': {
            color: 'white !important',
            fontFamily: 'cardiuma-regular',
            fontSize: '14px',
        },
        '& .MuiInputBase-input': {
            color: 'white !important',
        },
        "@media only screen and (max-width: 1620px)": {
            width: '190px !important'
        },
        "@media only screen and (max-width: 1420px)": {
            width: '180px !important'
        },
        "@media only screen and (max-width: 1350px)": {
            width: '170px !important'
        },
    }

    const smalltextFieldStyles = {
        marginRight: '10px !important',
        '& .MuiInputBase-root': {
            backgroundColor: '#131E2E !important',
            color: 'white !important',
            fontFamily: 'cardiuma-regular',
            fontSize: '15px'
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '131E2E !important',
        },
        '& .MuiInputLabel-root': {
            color: 'white !important',
            fontFamily: 'cardiuma-regular',
            fontSize: '14px',
        },
        '& .MuiInputBase-input': {
            color: 'white !important',
        },
        "@media only screen and (max-width: 1620px)": {
            width: '150px !important'
        },
        "@media only screen and (max-width: 1420px)": {
            width: '130px !important'
        },
        "@media only screen and (max-width: 1350px)": {
            width: '120px !important'
        },
    }

    return (
        //dev-trupti on 24-10-2024
        <div style={{ display: 'flex', alignItems: 'center' }} >
            <form
                // onSubmit={handleInCompleteKycSubmit}
                className={classes.kycFormInputField}
                // Adjusted margin - 07/08/24 - Dev Srini
                style={{ margin: '1% 0 1% 0' }}
            >
                <TextField
                    label="Initiated By"
                    variant="outlined"
                    value={fieldInitBy}
                    onChange={handleInitBy}
                    size='small'
                    sx={{ ...textFieldStyles }}
                />

                <TextField
                    label="Email ID"
                    variant="outlined"
                    value={fieldInitEmail}
                    onChange={handleEmail}
                    size='small'
                    sx={{ ...textFieldStyles }}
                // {...textFieldProps}
                />

                {/* <TextField
                    label="Mobile No"
                    variant="outlined"
                    // value={kycMobile}
                    // onChange={handleKycMobile}
                    size='small'
                    sx={{...textFieldStyles}}
                    // {...textFieldProps}

                /> */}
                {/* Added Aadhaar by dev-trupti on 26-08-2024 */}


                {/* Added REFCODE by dev-trupti on 22-10-2024 */}
                <TextField
                    label="Referral Code" //dev-trupti on 31-12-2024
                    variant="outlined"
                    value={fieldInitRefCode}
                    onChange={handleRefCode}
                    size='small'
                    sx={{ ...smalltextFieldStyles }}
                // {...smalltextFieldProps}

                />


                <Grid style={{ borderRadius: "5px" }}>
                    <FormControl size="small" style={{ width: "100%" }}>
                        <InputLabel className={classes.inputColor1} id="demo-select-small-label">
                            Status
                        </InputLabel>
                        <Select
                            className={classes.select1}
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={filterStatus}
                            label="Select"
                            onChange={(newValue) => { handleStatus(newValue) }}
                            displayEmpty
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        top: '50px'
                                    },
                                },
                            }}
                            sx={{
                                height: '40px',
                                ".css-hfutr2-MuiSvgIcon-root-MuiSelect-icon": {
                                    color: "#131E2E !important"
                                },
                                ".css-bpeome-MuiSvgIcon-root-MuiSelect-icon": {
                                    color: "#131E2E !important"
                                }
                            }}
                        >
                            <MenuItem className={classes.intSelText1} value="open">
                                open
                            </MenuItem>

                            <MenuItem className={classes.intSelText} value="closed">
                                closed
                            </MenuItem>
                            {/*<MenuItem className={classes.intSelText} value="Zero brokerage Year">
                                                        Zero Brokerage Year
                                                    </MenuItem> */}
                        </Select>
                    </FormControl>
                </Grid>

                <Button
                    onClick={handleFieldSubmit}
                    style={{
                        marginLeft: '20px',
                        width: '80px',
                        height: '40px',
                        padding: '8px 24px',
                        gap: '10px',
                        color: '#000000',
                        backgroundColor: '#F3D45E',
                        fontFamily: 'cardiuma-regular',
                        fontSize: '11px',
                        fontStyle: 'normal'
                    }}
                >
                    Submit
                </Button>
            </form>
            {/* dev-trupti on 24-10-2024 */}
            <Button
                onClick={handleReset}
                style={{
                    width: '80px',
                  
                    height: '40px',
                    padding: '8px 24px',
                    marginLeft: '10px',
                    gap: '10px',
                    color: '#000000',
                    backgroundColor: '#F3D45E',
                    fontFamily: 'cardiuma-regular',
                    fontSize: '11px',
                    fontStyle: 'normal',
                }}
            >
                Reset
            </Button>
            {/* srini - 21/11/24 */}
            <Button
                style={{
                    color: "#199DA9",
                    textDecoration: "underline",
                    fontFamily: 'cardiuma-regular',
                    fontSize: '13px',
                    fontStyle: 'normal',
                    fontWeight: 'bold',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                    height: '60px',
                    marginLeft: '10px',
                }}
                onClick={handleDownloadCsv}
            >
                Download CSV
            </Button>

        </div>
    )
}

export default withStyles(styles)(Fields);
